module.exports = "../../../../platform/assets/pageMainIcon/youth_jichudanganlei5.svg";